export default {
  published: 'Publicados',
  inProcess: 'Borradores',
  inRevision: 'En revisión',
  metrics: 'Métricas',
  backToKimple: 'Volver a Kimple',
  backToExplore: 'Volver a Explorar'
}

export const en = {
  published: 'Posted',
  inProcess: 'Drafts',
  inRevision: 'In review',
  metrics: 'Metrics',
  backToKimple: 'Back to Kimple',
  backToExplore: 'Back to Explore'
}

export const ca = {
  published: 'Publicats',
  inProcess: 'Esborranys',
  inRevision: 'En revisió',
  metrics: 'Mètriques',
  backToKimple: 'Tornar a Kimple',
  backToExplore: 'Tornar a Explora'
}
